var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f32",class:{'flag-circle': _vm.circle }},[_c('div',{staticClass:"flag-inner",class:{'flag-inner-circle': _vm.circle }},[_c('div',{staticClass:"flag",class:_vm.flagCode,style:('margin-left: 0px;')})])])}
var staticRenderFns = []

export { render, staticRenderFns }